<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-row>
        <v-col cols="12" md="4">
          <DateISOPickerMargin
            label="Ngày"
            :date.sync="time"
            outlined
            :rules="[$rules.date, $rules.dateFromNow]"
            dense
            :hide-details="false"
          />
        </v-col>
        <v-col cols="12" md="8">
          <GradeClassSelect @changed="gradeClassChange" />
        </v-col>
      </v-row>
    </div>
    <div class="filter-submit">
      <v-btn class="search-button mb-5" @click="onFilterChanged" outlined :disabled="isFilterDisabled"> Tìm kiếm </v-btn>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions, mapState } from 'vuex'
import { get } from 'lodash'
import GradeClassSelect from '@/components/basic/filter/GradeClassSelect.vue'
import DateISOPickerMargin from '../../../components/basic/picker/DateISOPickerMargin.vue'

export default {
  components: { DateISOPickerMargin, GradeClassSelect },
  data() {
    return {
      selectedGrade: {},
      selectedClass: {},
      time: moment().toISOString(),
    }
  },
  computed: {
    ...mapState('auth', ['role']),
    isFilterDisabled() {
      if (!this.time) return true
      if (this.role.type === 'teacher' && !get(this.selectedClass, '_id', '').length) return true
      return false
    }
  },
  // mounted() {
  //   this.onFilterChanged()
  // },
  methods: {
    ...mapActions('attendance', ['setDate']),
    gradeClassChange(data) {
      this.selectedGrade = data.grade
      this.selectedClass = data.class
    },

    onFilterChanged() {
      if (this.role.type === 'teacher') {
        if (!get(this.selectedClass, '_id', '').length) return this.$alert.error('Vui lòng chọn lớp')
      }
      const selectedDate = moment(this.time)
      const startOfDay = selectedDate.startOf('day').toISOString()
      const endOfDay = selectedDate.endOf('day').toISOString()

      this.setDate(startOfDay)

      const params = {
        date_gte: startOfDay,
        date_lte: endOfDay,
        grade: get(this.selectedGrade, '_id', ''),
        class: get(this.selectedClass, '_id', ''),
      }

      this.$emit('onFilterChanged', params)
    },
  },
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>
